export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" fill-rule="evenodd" d="M17.03 7.97a.75.75 0 0 1 0 1.06l-6.768 6.77a1 1 0 0 1-1.576-.211L6.85 12.372a.75.75 0 0 1 1.302-.744l1.513 2.647L15.97 7.97a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/>
    <path fill="currentcolor" fill-rule="evenodd" d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" clip-rule="evenodd"/>
</svg>
`;
